<template>
  <div>
    <b>{{selectedSubsidiary.title}}</b> / <b>{{selectedGroup.title}}</b>
    <br/>
    {{ settings['appointmentgroup.default.frontend.heading.calendar'].value }}
    <br/>
    <b-alert v-if="errors.NO_APPOINTMENTS_LEFT" variant="warning" class="m-5" show>{{ settings['appointmentgroup.default.frontend.message.no_tickets_available'].value }}</b-alert>
    <div class="row" v-if="!errors.NO_APPOINTMENTS_LEFT">
      <div class="col-12 col-md-12 col-sm-12 col-lg-12 col-xl-6 text-center">

        <flat-pickr
            v-model="selectedDay"
            :config="calendarConfig"
            class="mt-2"
            @input="onDayClick">
        </flat-pickr>

      </div>
      <div class="col-12 col-md-12 col-sm-12 col-lg-12 col-xl-6 p-3 pt-0 text-center">
        <div v-if="selectedDay"><b>{{selectedDay | moment('dddd, DD. MMMM YYYY')}}</b>
          <br/>
          {{ settings['appointmentgroup.default.frontend.heading.appointment'].value }}

          <b-form-group class="mt-2 font-monospace">
            <b-form-radio-group v-model="selectedDate" name="appointment">
              <b-form-radio v-for="appointment in availableSlots" :key="appointment.id" :value="appointment">
                <span v-if="appointment.date_end">{{ appointment.date | moment("HH:mm")}} - {{appointment.date_end | moment("HH:mm")}}</span>
                <span v-else>{{ appointment.date | moment("HH:mm")}}</span>
              </b-form-radio>
            </b-form-radio-group>
          </b-form-group>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import {German as GermanLocale} from 'flatpickr/dist/l10n/de.js';
import { BAlert, BFormGroup, BFormRadio, BFormRadioGroup } from 'bootstrap-vue'

export default {
  name: "Appointments",
  props: ['settings', 'selectedSubsidiary', 'selectedGroup', 'groupFilter'],
  components: {
    flatPickr,
    'b-alert': BAlert,
    'b-form-group': BFormGroup,
    'b-form-radio': BFormRadio,
    'b-form-radio-group': BFormRadioGroup,
  },
  data() {
    return {
      errors: [],
      availableSlots: [],
      selectedDay: null,
      selectedDate: null,
      calendarConfig: {
        inline: true,
        static: true,
        locale: GermanLocale,
        enable: [],
        minDate: null
      },
    }
  },
  mounted() {
    this.init()
  },
  watch: {
    selectedGroup: function() {
      this.init()
    },
    selectedDate: function() {
      this.$emit('date-change', this.selectedDate)
    }
  },
  methods: {
    async init() {
      this.selectedDay = null
      this.selectedDate = null
      this.availableSlots = []
      await this.getAvailableDates()
    },
    validate() {
      const isValid = (this.selectedDate !== null)
      return {
        selectedDate: this.selectedDate,
        isValid: isValid
      }
    },
    async getAvailableDates() {

      if(!this.selectedGroup) return

      this.errors = {}
      this.availableSlots = []

      const minDate = this.$moment().add(this.selectedGroup.offset_days_start, 'days').format("YYYY-MM-DD")
      const maxDate = this.$moment(minDate).add((this.selectedGroup.offset_days_length - 1), 'days').format("YYYY-MM-DD")
      const appointmentFilter = this.groupFilter.join(',')

      this.calendarConfig.enable = []

      const result = await this.axios.get('booking/appointments/?group=' + this.selectedGroup.id + '&from='+minDate+'&to=' + maxDate + "&appointment_filter=" + appointmentFilter)
      if(Object.keys(result.data).length === 0) {
        this.$set(this.errors, 'NO_APPOINTMENTS_LEFT', true)
      }
      else {

        for (const date in result.data) {
          this.calendarConfig.enable.push( date )
        }

        if (this.calendarConfig.enable.length > 0) {
          this.calendarConfig.minDate = this.calendarConfig.enable[0]
        }

        if (this.calendarConfig.enable.length === 1) {
          this.selectedDay = this.calendarConfig.enable[0]
        }

      }


    },
    onDayClick() {
      this.getAppointments()
    },
    async getAppointments() {
      this.selectedDate = null
      const appointmentFilter = this.groupFilter.join(',')
      const result = await this.axios.get('appointment-groups/' + this.selectedGroup.id + '/appointments?from='+this.selectedDay+'&to='+this.selectedDay+'&appointment_filter='+appointmentFilter)
      this.availableSlots = result.data.map(
          (obj) => {
            if (obj.date_end) {
              return {
                "id": obj.id,
                "text": this.$moment(obj.date).format("HH:mm"),
                "date": obj.date,
                "date_end": obj.date_end
              }
            }
            return {
              "id" : obj.id,
              "text" : this.$moment(obj.date).format("HH:mm"),
              "date" : obj.date
            };
          }
      );

      if(this.selectedDay && this.availableSlots.length === 1) {
        this.selectedDate = this.availableSlots[0]
      }

    },
  }
}
</script>

<style scoped>

</style>
